import { VatPatternTraductionDto } from "./vatpatterntraductiondto";

export class VatPatternDto {
    idVatPattern?: number;
    codePatternVat?: string;
    active?: string;
    vatPatternTraductionDto?: VatPatternTraductionDto[] = [];

    constructor(data?: Partial<VatPatternDto>) {
        Object.assign(this, data);
    }
}

